<template>
  <div>
    <v-container style="max-width: 600px">
      <v-row>
        <v-col>
          <v-card>
            <v-card-title> Controle de Funcionalidades </v-card-title>

            <v-list>
              <v-list-item
                v-for="feature in features"
                :key="feature.id"
                link
                @click="
                  handleSwitch(feature.slug, feature.id, !feature.is_active)
                "
              >
                <v-list-item-action>
                  <v-switch
                    :input-value="feature.is_active"
                    @change.stop="
                      handleSwitch(feature.slug, feature.id, $event)
                    "
                    inset
                  ></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ feature.name }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu v-if="feature.description" offset-y>
                    <template #activator="{ on, props, value }">
                      <v-btn v-bind="props" v-on="on" icon>
                        <v-icon v-if="value">mdi-help-circle</v-icon>
                        <v-icon v-else>mdi-help-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card width="300" dark>
                      <v-card-text v-html="feature.description"> </v-card-text>
                    </v-card>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ToastsMixin from "@/mixins/ToastsMixin.vue";

import {
  index,
  updateActive,
  bulkUpdateActive,
} from "@/services/system/feature_flags";

export default {
  mixins: [ToastsMixin],

  components: {},

  props: {},

  data() {
    return {
      features: [],
      loading: false,
      changed: false,
    };
  },

  methods: {
    async loadFeatures() {
      this.loading = true;

      try {
        const { data } = await index();
        this.features = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    getFeatureValue(featureId) {
      return this.features.find((feature) => feature.id === featureId)
        ?.is_active;
    },

    getFeatureName(featureId) {
      return this.features.find((feature) => feature.id === featureId)?.name;
    },

    updateSwitch(featureId, value) {
      this.features = this.features.map((feature) => {
        if (feature.id !== featureId) {
          return feature;
        }

        return {
          ...feature,
          is_active: value,
        };
      });
    },

    async handleSwitch(featureSlug, featureId, value) {
      const old = this.getFeatureValue(featureId);

      this.updateSwitch(featureId, value);

      try {
        await updateActive(featureId, {
          value,
        });
        const action = value ? "ativo" : "inativo";

        this.toast(this.getFeatureName(featureId) + " agora está " + action);
        this.$store.commit("feature_flags/resetFeature", featureSlug);
      } catch (error) {
        console.error(error);
        this.toastError("Falha ao mudar o estado da funcionalidade");

        this.updateSwitch(featureId, old);
      }
    },
  },

  computed: {},

  created() {
    this.loadFeatures();
  },
};
</script>
